import React from 'react';

export const UserEditorContext = React.createContext({
	updatedCustomers: {} as any,
	setUpdatedCustomers: (func: any) => {},
});
